export default __webpack_public_path__ + "static/emoji1-d25e00ef6a02ca11f7e848b4873e91b7.gif";